import React, { Component } from "react";
import { Link } from "react-router-dom";
import logo2 from '../images/logo2.png'
import logo from '../images/ipark-logo.png';
import "../styles/login.css"
import Navbar from '../components/NavbarHome'

import { connect } from "react-redux";
import { signupUser } from "../redux/actions/userActions";

import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

// MUI
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

class Signup extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      confirmPassword: "",
      username: "",
      errors: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ui.errors) {
      this.setState({ errors: nextProps.ui.errors });
    }
  }

  handleSubmit = e => {
    e.preventDefault();

    const newUserDetails = {
      email: this.state.email,
      password: this.state.password,
      confirmPassword: this.state.confirmPassword,
      username: this.state.username
    };

    this.props.signupUser(newUserDetails, this.props.history);
  };

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleEnter = e => {
    e.preventDefault();
    if (e.keyCode === 13) {
      this.handleSubmit(e);
    }
  };

  render() {
    const {
      ui: { loading }
    } = this.props;
    const { errors } = this.state;
    return (
      <div>
        <Navbar />
        <div className="container signUp-container">
          <div className="row text-center justify-content-center m-3">
            <div className="col-lg-5 border left-div">
              <form>
                <img src={logo} alt="logo" className="logo" />
                <div>
                  <TextField
                    id="email"
                    name="email"
                    type="email"
                    label="Email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    onKeyUp={this.handleEnter}
                    helperText={errors.email}
                    error={errors.email ? true : false}
                    placeholder="Enter email here"
                    disabled={loading}
                  />
                </div>
                <div>
                  <TextField
                    id="username"
                    name="username"
                    label="Username"
                    type="text"
                    value={this.state.username}
                    onChange={this.handleChange}
                    onKeyUp={this.handleEnter}
                    helperText={errors.username}
                    error={errors.username ? true : false}
                    placeholder="Enter username here"
                    disabled={loading}
                  />
                </div>
                <div>
                  <TextField
                    id="password"
                    name="password"
                    label="Password"
                    type="password"
                    value={this.state.password}
                    onChange={this.handleChange}
                    onKeyUp={this.handleEnter}
                    helperText={errors.password}
                    error={errors.password ? true : false}
                    placeholder="Enter password here"
                    disabled={loading}
                  />
                </div>
                <div>
                  <TextField
                    id="confirmPassword"
                    name="confirmPassword"
                    type="password"
                    label="Confirm Password"
                    value={this.state.confirmPassword}
                    onChange={this.handleChange}
                    onKeyUp={this.handleEnter}
                    helperText={errors.confirmPassword}
                    error={errors.confirmPassword ? true : false}
                    placeholder="Enter password here"
                    disabled={loading}
                  />
                </div>
                <hr />
                {errors.general && (
                  <Typography variant="body2">{errors.general}</Typography>
                )}
                <div className="button-login-div">
                  <Button
                    variant="outline-primary"
                    className="submitButton"
                    type="submit"
                    name="signupButton"
                    onClick={this.handleSubmit}
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner
                        className="spinner"
                        animation="border"
                        role="status"
                        size="sm"
                      />
                    ) : (
                        "Signup"
                      )}
                  </Button>
                </div>
                <small>
                  {" "}
                  Already have an account? Login <Link to="/login"> here </Link>{" "}
                </small>
              </form>
            </div>
            <div className="col-lg-5 border rightDivSignUp">
              <div className="right-div-content">
                <img src={logo2} alt="iPark" className="logo2" />
                <h6 className="h6">Online Web Application for Parking Assistance <br /> and Reservation</h6>
              </div>
            </div>
          </div>
        </div>
      </div >

    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  ui: state.ui
});

const mapActionsToProps = {
  signupUser
};

export default connect(mapStateToProps, mapActionsToProps)(Signup);
